import React, { useState } from "react";
import {
  Popover,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Tooltip,
  CircularProgress,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
  Check as AcceptIcon,
  Flag as ResolveIcon,
  Archive as ArchiveIcon,
} from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  popover: {
    "& .MuiPopover-paper": {
      borderRadius: 8,
      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
      border: "1px solid rgba(0, 0, 0, 0.1)",
    },
  },
  listItem: {
    padding: theme.spacing(1, 2),
    minWidth: 150,
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  listItemIcon: {
    minWidth: 36,
  },
  listItemText: {
    "& .MuiListItemText-primary": {
      fontSize: "14px",
      fontWeight: 500,
    },
  },
}));

const BulkActionsPopup = ({
  anchorEl,
  open,
  onClose,
  status,
  onAccept,
  onResolve,
  onArchive,
  acceptLoading = false,
  resolveLoading = false,
  archiveLoading = false,
  disabled = false,
}) => {
  const classes = useStyles();

  const handleAction = (action) => {
    switch (action) {
      case "accept":
        onAccept();
        break;
      case "resolve":
        onResolve();
        break;
      case "archive":
        onArchive();
        break;
    }
    onClose();
  };

  const getAvailableActions = () => {
    const actions = [];

    // Se estiver na aba "pending" (Waiting), mostrar opções de aceitar, resolver e arquivar
    if (status === "pending") {
      actions.push(
        {
          id: "accept",
          label: "Aceitar",
          icon: <AcceptIcon fontSize="small" />,
          loading: acceptLoading,
        },
        {
          id: "resolve",
          label: "Resolver",
          icon: <ResolveIcon fontSize="small" />,
          loading: resolveLoading,
        },
        {
          id: "archive",
          label: "Arquivar",
          icon: <ArchiveIcon fontSize="small" />,
          loading: archiveLoading,
        }
      );
    }

    // Se estiver na aba "open" (Attending), mostrar opções de arquivar e resolver
    if (status === "open") {
      actions.push(
        {
          id: "archive",
          label: "Arquivar",
          icon: <ArchiveIcon fontSize="small" />,
          loading: archiveLoading,
        },
        {
          id: "resolve",
          label: "Resolver",
          icon: <ResolveIcon fontSize="small" />,
          loading: resolveLoading,
        }
      );
    }

    // Se estiver na aba "closed" ou "archived", não mostrar ações (tickets já finalizados)
    if (status === "closed" || status === "archived") {
      return [];
    }

    return actions;
  };

  const availableActions = getAvailableActions();

  // Se não há ações disponíveis, não mostrar o popup
  if (availableActions.length === 0) {
    return null;
  }

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      className={classes.popover}
    >
      <List dense>
        {availableActions.map((action) => (
          <ListItem
            key={action.id}
            button
            onClick={() => handleAction(action.id)}
            disabled={disabled || action.loading}
            className={classes.listItem}
          >
            <ListItemIcon className={classes.listItemIcon}>
              {action.loading ? (
                <CircularProgress size={20} />
              ) : (
                action.icon
              )}
            </ListItemIcon>
            <ListItemText
              primary={action.label}
              className={classes.listItemText}
            />
          </ListItem>
        ))}
      </List>
    </Popover>
  );
};

export default BulkActionsPopup; 